import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "equipment" }

import { onMounted, ref } from 'vue';
import PeripheralEquipmentIcon from '@/components/VehicleParts/PeripheralEquipmentIcon'
import {
  PERIPHERAL_EQUIPMENT_LIST,
  ICON_NONE,
  TYPE_CAMERA,
  TYPE_TDSENSOR,
  TYPE_ETC,
  CONNECT_STATUS_ON
} from '@/services/consts/vehicle'

type VehicleParameterType = {
  [key: string]: string | VehicleParameterType
}
type EquipmentType = {
  icon: string,
  type: string,
  name: string,
  path: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PeripheralEquipmentColumn',
  props: {
    parameters: {}
  },
  setup(__props: any) {

const props = __props

const cameraEquipments = ref<EquipmentType[]>([])
const tdsensorEquipments = ref<EquipmentType[]>([])
const etcEquipments = ref<EquipmentType[]>([])

onMounted(() => {
  PERIPHERAL_EQUIPMENT_LIST.forEach((equipment) => {
    const copyedEquipment = JSON.parse(JSON.stringify(equipment));
    const path = equipment.path as string
    const connectStatus = getConnectStatusByPath(props.parameters, path)

    if (connectStatus != CONNECT_STATUS_ON) {
      copyedEquipment.icon = ICON_NONE
    }

    let tdsensorRootStatus
    switch (equipment.type) {
      case TYPE_CAMERA:
        cameraEquipments.value.push(copyedEquipment)
        break;

      case TYPE_TDSENSOR:
        tdsensorRootStatus = getConnectStatusByPath(props.parameters, 'tdsensor.tdrfsensor')
        if (tdsensorRootStatus != CONNECT_STATUS_ON) {
          copyedEquipment.icon = ICON_NONE
        }
        tdsensorEquipments.value.push(copyedEquipment)
        break;

      case TYPE_ETC:
        etcEquipments.value.push(copyedEquipment)
        break;
    }
  })
})

function getConnectStatusByPath(parameters: VehicleParameterType, path: string): string {
  let device = {} as VehicleParameterType
  const keys = path.split('.');
  if (parameters[keys[0]]) {
    device = parameters[keys[0]] as VehicleParameterType
  }

  if(device && device[keys[1]]) {
    return device[keys[1]] as string
  }

  return ''
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameraEquipments.value, (equipment) => {
        return (_openBlock(), _createBlock(_unref(PeripheralEquipmentIcon), {
          key: equipment.path,
          equipment: equipment
        }, null, 8, ["equipment"]))
      }), 128))
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tdsensorEquipments.value, (equipment) => {
        return (_openBlock(), _createBlock(_unref(PeripheralEquipmentIcon), {
          key: equipment.path,
          equipment: equipment
        }, null, 8, ["equipment"]))
      }), 128))
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(etcEquipments.value, (equipment) => {
        return (_openBlock(), _createBlock(_unref(PeripheralEquipmentIcon), {
          key: equipment.path,
          equipment: equipment
        }, null, 8, ["equipment"]))
      }), 128))
    ])
  ]))
}
}

})